"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useId } from "react";
import classNames from "classnames";
import { Card } from "./Card/Card.js";
export function usePopover(id) {
    const fallbackId = useId();
    const popover = {
        id: id ?? fallbackId,
        popover: "auto",
        onBeforeToggle: (event) => {
            if (event.newState === "open") {
                document.body.style.overflow = "hidden";
            }
            else {
                document.body.style.overflow = "";
            }
        },
    };
    const trigger = {
        popoverTarget: popover.id,
    };
    return { popover, trigger };
}
export function DropdownMenu({ children, as, className, ...rest }) {
    const Component = as ?? Card;
    return (_jsx(Component, { as: as, ...rest, popover: "auto", className: classNames(className, "backdrop:bg-black backdrop:opacity-50 backdrop:transition-all starting:backdrop:opacity-0", "pointer-events-none transition-all open:pointer-events-auto open:opacity-100 sm:opacity-0 sm:starting:open:opacity-0", "top-[unset] right-0 bottom-0 left-0 w-full rounded-t-2xl pt-6", "sm:w-fit sm:rounded-2xl sm:pt-4 sm:supports-[left:anchor(left)]:left-[anchor(left)] sm:supports-[top:anchor(bottom)]:top-[anchor(bottom)]"), children: children }));
}
